import CreateStructureAssessmentContainer from './CreateStructureAssessmentContainer'

export default CreateStructureAssessmentContainer
